// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "bd34fc4";
